<template>
  <div id="app">
    <notification-modal v-if="isNotificationOpened"/>
    <control-point v-if="isControlPointOpened"/>
    <control-point-request v-if="isControlPointRequestOpened"/>
    <router-view/>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ControlPoint from '@/components/ControlPoint.vue';
import ControlPointRequest from '@/components/ControlPointRequest.vue';
import NotificationModal from '@/components/NotificationModal.vue';

export default {
  name: 'App',
  components: {
    ControlPoint,
    ControlPointRequest,
    NotificationModal,
  },
  computed: {
    ...mapState('projects', ['isControlPointOpened', 'isControlPointRequestOpened', 'isNotificationOpened']),
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/main.scss";
</style>
